var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlandIslands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.181 322.783C508.92 301.489 512 279.107 512 256C512 232.893 508.92 210.511 503.181 189.217L233.739 0.974121C183.718 5.28412 137.815 23.9741 100.174 52.8951L8.819 189.217C3.08 210.511 0 232.893 0 256C0 278.972 3.043 301.231 8.718 322.413L100.173 459.105C137.814 488.026 183.717 506.717 233.738 511.026L503.181 322.783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81934 322.783C23.6313 377.742 56.2763 425.376 100.174 459.105V322.783H8.81934Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.739 511.026C241.077 511.658 248.498 512 256 512C374.279 512 473.805 431.779 503.181 322.783H233.739V511.026Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.181 189.217C473.805 80.221 374.279 0 256 0C248.498 0 241.077 0.342 233.739 0.974V189.217H503.181Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.174 52.895C56.2763 86.625 23.6313 134.258 8.81934 189.217H100.174V52.895Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.833 222.609H200.349H200.348V6.08496C176.69 11.331 154.261 19.834 133.565 31.127V222.608H2.167C0.742 233.539 0 244.683 0 256C0 267.317 0.742 278.461 2.167 289.391H133.564H133.565V480.872C154.261 492.164 176.69 500.669 200.348 505.914V289.394V289.392H509.833C511.256 278.461 512 267.317 512 256C512 244.683 511.256 233.539 509.833 222.609V222.609Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlandIslands);
export default __webpack_public_path__ + "static/media/alandIslands.aa93b33de612a20a647296ebbf78c3b0.svg";
export { ForwardRef as ReactComponent };